import React from "react"

import { Wrapper, Content, CopyRight } from "./Footer.styles"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

// icons
import {
  faFacebookF,
  faTwitter,
  faInstagram,
  faGithub,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons"

const Footer = () => (
  <Wrapper>
    <Content>
      <div className="SocialLinks">
        <a
          href="mailto: mohamed.a.hamaida@gmail.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="socialIcon">
            <FontAwesomeIcon icon={faLinkedinIn} />
          </div>
        </a>

        <a
          href="https://twitter.com/Moh_Hamaida"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="socialIcon">
            <FontAwesomeIcon icon={faTwitter} />
          </div>
        </a>

        <a
          href="https://github.com/mohamedhmda"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="socialIcon">
            <FontAwesomeIcon icon={faGithub} />
          </div>
        </a>
        <a
          href="https://www.facebook.com/profile.php?id=100014322403921"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="socialIcon">
            <FontAwesomeIcon icon={faFacebookF} />
          </div>
        </a>

        <a
          href="https://www.facebook.com/profile.php?id=100014322403921"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="socialIcon">
            <FontAwesomeIcon icon={faInstagram} />
          </div>
        </a>
      </div>
      <CopyRight>© 2022-Today/ Copyright Hamaida mohamed amine</CopyRight>
    </Content>
  </Wrapper>
)

export default Footer
